<section class="contact-section container-fluid sts-section">
  <app-sts-section-header key="sts-contact-techinical-support" >Contact Technical Support</app-sts-section-header>

  <app-sts-section-body key="sts-contact-techinical-support-instructions">
    <!-- content is served by CMS -->
  </app-sts-section-body>

  <app-sts-lower-bar>
    <a href="/" app-sts-cms-txt key="sts-go-back" class="sts-btn">Go Back</a>
  </app-sts-lower-bar>

</section>
